/* eslint-disable max-classes-per-file */
import { AddFutureDays } from "@libs/utils/date"
import { Serializable, jsonProperty } from "ts-serializable"

import { BrandDetail } from "@infra/models/Brands"
import CirculationPlaceItem from "@infra/models/CirculationPlace"
import { ModelDetail } from "@infra/models/Model"

export class RequestResponse extends Serializable {
  @jsonProperty(String, null)
  id = ""

  @jsonProperty(String, null)
  mensaje = ""
}

export class VehicleGroup extends Serializable {
  @jsonProperty(Number, null)
  id = null

  @jsonProperty(Number, null)
  grupoId = null

  @jsonProperty(String, null)
  modeloVehiculoId = null

  @jsonProperty(String, null)
  marcaVehiculoId = null

  @jsonProperty(Number, null)
  claseVehiculoId = null

  @jsonProperty(Number, null)
  tipoVehiculoId = null

  @jsonProperty(Number, null)
  usoVehiculoId = null

  @jsonProperty(Number, null)
  minAsientos = null

  @jsonProperty(Number, null)
  maxAsientos = null

  @jsonProperty(String, null)
  tipoRegla = null
}

export class ModelDetailPlate extends ModelDetail {
  @jsonProperty(String, null)
  placa = null

  @jsonProperty(Number, null)
  ano = null

  @jsonProperty(String, null)
  numMotor = ""

  @jsonProperty(String, null)
  numSerieChasisMotor = ""

  @jsonProperty(String, null)
  codUso = ""

  @jsonProperty(String, null)
  descUso = ""

  @jsonProperty(Number, null)
  cantAsiento = null

  @jsonProperty(BrandDetail)
  marcas: BrandDetail = new BrandDetail()

  @jsonProperty(String, null)
  descClaseVeh = ""

  @jsonProperty(String, null)
  descTipoVeh = ""

  @jsonProperty(String, null)
  tipoVeh = ""
}

export class Quote extends Serializable {
  @jsonProperty(String, null)
  solicitudId = ""

  @jsonProperty(Number, null)
  precio = 0

  @jsonProperty(Number, null)
  precioRenovacion = 0

  @jsonProperty(Number)
  priceFinal = 0

  @jsonProperty(Number, null)
  tarifa = null

  @jsonProperty(Number, null)
  tarifaRenovacion = null

  @jsonProperty(Number)
  numSecuencial = ""

  @jsonProperty(String, null)
  fechaFinCoverturaApeseg = null

  @jsonProperty(Number, null)
  selectedPlanType = null

  @jsonProperty(String, null)
  fechaInicioVigencia = ""

  @jsonProperty(Boolean, null)
  flagErrorApeseg = null

  @jsonProperty(String, null)
  sessionKey = ""

  @jsonProperty(String, null)
  jobId = ""
}

export class ChannelProductUrlResponse extends Serializable {
  @jsonProperty(Number, null)
  channelId = ""

  @jsonProperty(String, null)
  nombre = ""

  @jsonProperty(String, null)
  url = ""

  @jsonProperty(String, null)
  codigoUa = ""

  @jsonProperty(String, null)
  producto = ""

  @jsonProperty(Array<any>, null)
  data: Array<any> = []
}

export class CustomerResponse extends Serializable {
  @jsonProperty(Number, null)
  id = null

  @jsonProperty(String, null)
  documentType = ""

  @jsonProperty(String, null)
  documentId = ""

  @jsonProperty(String, null)
  names = ""

  @jsonProperty(String, null)
  firstSurname = ""

  @jsonProperty(String, null)
  lastSurname = ""

  @jsonProperty(String, null)
  birthDate = ""

  @jsonProperty(String, null)
  mobile = ""

  @jsonProperty(String, null)
  email = ""

  @jsonProperty(String, null)
  ubigeo = null

  @jsonProperty(String, null)
  address = ""

  @jsonProperty(String, null)
  nationality = ""

  @jsonProperty(String, null)
  gender = ""

  @jsonProperty(Boolean, null)
  verified = false

  @jsonProperty(String, null)
  clientType = ""

  @jsonProperty(Boolean)
  promotional = false

  @jsonProperty(String, null)
  departmentCode = null

  @jsonProperty(String, null)
  provinceCode = null

  @jsonProperty(String, null)
  districtCode = null

  @jsonProperty(String, null)
  department = null

  @jsonProperty(String, null)
  province = null

  @jsonProperty(String, null)
  district = null

  @jsonProperty(Boolean, null)
  hasBirthday = false
}

export class PlateInfo extends Serializable {
  @jsonProperty(Boolean, null)
  requestOk: boolean | null = null

  @jsonProperty(Boolean, null)
  vehicleInfoOk: boolean | null = null

  @jsonProperty(Boolean, null)
  circulationPlaceOk: boolean | null = null

  @jsonProperty(Boolean, null)
  vehicleGroupOk: boolean | null = null

  @jsonProperty(Boolean, null)
  customerOk: boolean | null = null

  @jsonProperty(Boolean, null)
  channelOk: boolean | null = null

  @jsonProperty(Boolean, null)
  quoteOk: boolean | null = null

  @jsonProperty(RequestResponse, null)
  requestResponse: RequestResponse = new RequestResponse()

  @jsonProperty(ModelDetailPlate, null)
  consultaVehiculoResponse: ModelDetailPlate = new ModelDetailPlate()

  @jsonProperty([CirculationPlaceItem], null)
  circulationPlaceResponseList: Array<CirculationPlaceItem> = []

  @jsonProperty(VehicleGroup, null)
  vehicleGroupResponse: VehicleGroup = new VehicleGroup()

  @jsonProperty(CustomerResponse, null)
  fullCustomerResponse: CustomerResponse = new CustomerResponse()

  @jsonProperty(ChannelProductUrlResponse, null)
  channelProductUrlResponse: ChannelProductUrlResponse = new ChannelProductUrlResponse()

  @jsonProperty(Quote, null)
  quoteResponse: Quote = new Quote()

  @jsonProperty(String, null)
  circulationPlaceResponse: string | null = ""
}
export class PlateFull extends Serializable {
  @jsonProperty(PlateInfo)
  datos: PlateInfo = new PlateInfo()
}
